import React from 'react';
import {toTurkishUpperCase} from '../utils/turkishCase';

/** Form bölüm etiketi — CSS text-transform: uppercase Türkçe İ→I hatası verir */
export function FieldLabel({children, className, style, as: Tag = 'span'}) {
  return (
    <Tag className={className} style={style}>
      {toTurkishUpperCase(children)}
    </Tag>
  );
}
